import styled from 'styled-components';
import { SIZING } from '../../styles/variables';
import { device } from '../../styles/devices';

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${SIZING.unit(3)};
  margin-top: ${SIZING.unit(4.5)};
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(6.5)};
    margin-bottom: 12px;
  }
  @media ${device.laptop} {
    padding-top: 52px;
    margin-left: 60px;
    margin-right: 60px;
    margin-top: 0;
    margin-bottom: 32px;
  }
  @media ${device.laptopL} {
    margin-left: 96px;
    margin-right: 96px;
  }
`;
